import { EpocusLogomark } from "$components/epocus-logomark";
import { useAuth0 } from "@auth0/auth0-react";
import { AppBar, Box, styled, Toolbar, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { linkToEpocusHome, linkToEpocusSettings } from "../links";
import { EpocusAvatar } from "./epocus-avatar";
import {
  EPOCUS_BORDER,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";
import { epocusTheme } from "./epocus-theme-provider";
import { WorkModeSwitch } from "./work-mode-switch";

const BrandGroup = styled(Link)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

const AppName = styled(Typography)({
  color: EPOCUS_TEXT_PRIMARY,
  fontWeight: 700,
  fontSize: rem(20),
});

const SettingsLink = styled(Link)({
  display: "inline-flex",
  textDecoration: "none",
  cursor: "pointer",
});

const BAR = {
  backgroundColor: EPOCUS_WHITE,
  boxShadow: `0 1px 0 0 ${EPOCUS_BORDER}`,
  color: "inherit",
  "& .MuiToolbar-root": {
    minHeight: 56,
    gap: 12,
  },
} as const;

const StyledAppBar = styled(AppBar)({
  ...BAR,
  // Sidebar replaces header on tablet+
  [epocusTheme.breakpoints.up("sm")]: {
    display: "none",
  },
});

const PersistentAppBar = styled(AppBar)({ ...BAR });

export const EpocusHeader: FC<{ persistent?: boolean }> = ({ persistent }) => {
  const { user } = useAuth0();
  const Bar = persistent ? PersistentAppBar : StyledAppBar;

  return (
    <Bar position="sticky" elevation={0}>
      <Toolbar>
        <BrandGroup to={linkToEpocusHome()} aria-label="Go to home">
          <EpocusLogomark size={32} />
          <AppName variant="h6">ePOCUS</AppName>
        </BrandGroup>
        <Box flex={1} />
        <WorkModeSwitch />
        <SettingsLink to={linkToEpocusSettings()} aria-label="Open settings">
          <EpocusAvatar name={user?.name} size={36} />
        </SettingsLink>
      </Toolbar>
    </Bar>
  );
};
